export const environment = {
  production: true,
  basePortalUrl: 'https://cms.preprod.ark.wine',
  authUrl: 'https://identity.preprod.nationalstorage.com.au',
  userManagementUrl: 'https://api.preprod.ark.wine/usermanagement',
  referenceDataUrl: 'https://api.preprod.ark.wine/referencedata',
  facilityManagementUrl: 'https://api.preprod.ark.wine/facilitymanagement',
  storageManagementUrl: 'https://api.preprod.ark.wine/storagemanagement',
  billingUrl: 'https://api.preprod.ark.wine/billing',
  paymentsUrl: 'https://api.preprod.ark.wine/payments',
  marketplaceUrl: 'https://api.preprod.ark.wine/marketplace',
  logisticsUrl: 'https://api.preprod.ark.wine/logistics',
  notificationsUrl: 'https://api.preprod.ark.wine/notifications',
  marketplaceClientUrl: 'https://marketplace.preprod.ark.wine',
  inactivityMonitorIdle: '15',
  inactivityMonitorTimeout: '30',
  showBottleDetailsQRCode: 'true',
  isAccountClosingFeatureEnabled: true,
  sentryDsn: "",
  sentryEnvironmentName: "",
  apiBaseUrl: '#{Api_BaseUrl}'
};
